// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
export const redirectWindowUrl = (url) => {
  if (url) {
    window.open(url, "_blank");
  }
};

export const redirectUrl = (url) => {
  if (url) {
    // window.open(url);
    window.location.href = url;
  }
};

export const setServiceUserIdSession = (serviceUserId) => {
  if (serviceUserId) {
    localStorage.setItem("getServiceUserId", serviceUserId);
    redirectUrl("/service-user-details");
  }
};

export const openNewTabWithId = (id, pathUrl, windowParam) => {
  let checkFunctionExecution = false;
  if (id) {
    const newTab = window.open(pathUrl, windowParam === "current" ? "_self" : "_blank");
    if (newTab) {
      newTab.name = JSON.stringify({ lastInsertId: id }); // Store data in `window.name`
      checkFunctionExecution = true;
    } else {
      console.error("Popup blocked! Please allow pop-ups for this site.");
    }
  } else {
    console.error("Invalid ID");
  }
  return checkFunctionExecution;
};
